var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11506_31331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99912 4.00001H13.0603C12.4461 2.93583 11.5626 2.05212 10.4985 1.43772C9.43443 0.823328 8.22736 0.499914 6.99866 0.5C5.76995 0.500086 4.56293 0.823668 3.49895 1.43821C2.43497 2.05275 1.55154 2.93659 0.9375 4.00086L3.96809 9.25001L3.9708 9.24931C3.66251 8.71768 3.49982 8.11417 3.49913 7.49962C3.49844 6.88507 3.65977 6.2812 3.96687 5.74888C4.27397 5.21656 4.71597 4.7746 5.24832 4.46756C5.78068 4.16052 6.38457 3.99926 6.99912 4.00001Z",
    fill: "url(#paint0_linear_11506_31331)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99902 4.51855C8.64518 4.51855 9.98029 5.8529 9.98047 7.49902C9.98047 9.14529 8.64529 10.4805 6.99902 10.4805C5.3529 10.4803 4.01855 9.14518 4.01855 7.49902C4.01873 5.85301 5.35301 4.51873 6.99902 4.51855Z",
    fill: "#1A73E8",
    stroke: "#FCFEFF",
    strokeWidth: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0299 9.24994L6.9993 14.4991C8.228 14.4993 9.43509 14.1759 10.4992 13.5616C11.5633 12.9473 12.4469 12.0637 13.0612 10.9995C13.6755 9.9354 13.9987 8.72829 13.9985 7.4996C13.9983 6.2709 13.6746 5.06391 13.0599 4H6.99878L6.99805 4.00271C7.6126 4.00153 8.2166 4.16238 8.74917 4.46905C9.28174 4.77573 9.72404 5.21738 10.0315 5.7495C10.339 6.28162 10.5007 6.88538 10.5004 7.49994C10.5001 8.11449 10.3378 8.71811 10.0299 9.24994Z",
    fill: "url(#paint1_linear_11506_31331)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.96869 9.25111L0.938093 4.00195C0.323588 5.06595 4.57949e-05 6.27299 4.86109e-09 7.50169C-4.57852e-05 8.7304 0.323406 9.93746 0.937832 11.0015C1.55226 12.0655 2.436 12.9491 3.5002 13.5632C4.5644 14.1774 5.77154 14.5006 7.00024 14.5002L10.0308 9.25105L10.0289 9.24907C9.72262 9.78187 9.28131 10.2245 8.74944 10.5324C8.21756 10.8403 7.61392 11.0025 6.99937 11.0027C6.38482 11.0029 5.78107 10.8411 5.24899 10.5336C4.71691 10.2261 4.2753 9.78371 3.96869 9.25111Z",
    fill: "url(#paint2_linear_11506_31331)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11506_31331",
    x1: 0.9375,
    y1: 4.87501,
    x2: 13.0603,
    y2: 4.87501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11506_31331",
    x1: 6.04298,
    y1: 14.4055,
    x2: 12.1044,
    y2: 3.90684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11506_31331",
    x1: 7.75729,
    y1: 14.0631,
    x2: 1.69587,
    y2: 3.56445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11506_31331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleChrome);
export default __webpack_public_path__ + "static/media/google-chrome.30ebcbade63d7c04874456366c404ae7.svg";
export { ForwardRef as ReactComponent };